import { Select } from 'antd';

import CountryPreview from 'components/CountryPreview';

import SelectCommon from '../common/SelectCommon/SelectCommon';
import { SelectValue } from '../filter.types';

interface CountrySelectWrapperProps {
  value: string | undefined;
  placeholder: string;
  options: { label: string; value: string; key: string }[];
  onChange: (value: SelectValue) => void;
  loading: boolean;
  className?: string;
  disabled: boolean;
  hasAccessToFilter: boolean;
  title: string;
  singleMode?: boolean;
}

const CountrySelectWrapper = ({
  value,
  placeholder,
  options,
  onChange,
  loading,
  className,
  disabled,
  hasAccessToFilter,
  title,
  singleMode = true
}: CountrySelectWrapperProps) => (
  <SelectCommon
    title={title}
    value={value ? [value] : undefined}
    placeholder={placeholder}
    customOptions={options.map((option) => (
      <Select.Option key={option.value} value={option.value}>
        <CountryPreview countryCode={option.value} countryName={option.label} />
      </Select.Option>
    ))}
    onChange={onChange}
    optionFilterProp="children"
    loading={loading}
    className={className}
    disabled={disabled}
    singleMode={singleMode}
    hasAccessToFilter={hasAccessToFilter}
  />
);

export default CountrySelectWrapper;
